@if (!erreurRecuperation()) {
  <div class="blast">
    <app-liste-generique [proprietesAffichees]="proprietesAfficheesTirs()" [hauteurListe]="72" [listeObjets]="tabTirs()" [filtreParDefaut]="{'prop':'estRealise','val':'false','type':'boolean'}"
    (clicObjetEvent)="ouvrirTir($event)" [triParDefaut]="{'prop':'nomProjet', 'type':'string'}"></app-liste-generique>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}
